/* app/js/src/components/media-transcoder/jobs/job-settings/media-files-landzone/media-files-landzone.component.scss */
.container {
  width: 100%;
  height: 100%;
}
.container.disabled {
  background-color: #eaeaea !important;
}
.container.disabled tr {
  background-color: #eaeaea !important;
}
.container.disabled tr.trimmed {
  background-color: #eaeaea !important;
}
.container .media-list table {
  width: 100%;
  text-align: left;
}
.container .media-list table tr {
  border-bottom: 1px solid white;
}
.container .media-list table thead tr {
  background-color: #dde3e7;
}
.container .media-list table tbody tr.selected {
  background-color: #e6f2fe !important;
}
.container .media-list table tbody tr.trimmed {
  background-color: #89e288 !important;
}
.container .media-list table tbody tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.container .media-list table tbody tr:hover {
  background-color: #e7dfdf;
}
.container .media-list table th,
.container .media-list table td {
  width: 33.3333333333%;
  padding-top: 0.3vw;
  padding-bottom: 0.3vw;
  padding-left: 0.5vw;
}
.container .truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 7vw;
}
.container .dropbox {
  text-align: center;
  width: 100%;
  height: 100%;
}
.container .dropbox .drop-area {
  width: 100%;
  height: 100%;
  border: 1px dashed #c6d2df;
  display: flex;
  justify-content: center;
  gap: 5px;
  align-items: center;
  color: #7d8fa1;
}
.container .dropbox .drop-area:hover {
  border-color: #40c4ff;
  color: #40c4ff;
}
.container .action-buttons {
  display: flex;
  justify-content: flex-end;
}
.container .action-buttons .trim-btn {
  cursor: pointer;
  width: 20px;
  height: 20px;
  color: #40c4ff;
  line-height: 14px;
  font-size: 20px;
  margin-bottom: 1px;
  margin-right: 1vw;
}
.container .action-buttons .trim-btn:before {
  content: "[...]";
}
.container .action-buttons .trim-btn:hover {
  color: black;
}
.container .disabled-overlay {
  background-color: red;
}
/*# sourceMappingURL=media-files-landzone.component.css.map */
